<template>
  <b-form>
    <b-row class="mb-3">
      <b-col> <b-form-checkbox v-model="teste"> Exibir usuários de teste </b-form-checkbox></b-col>
    </b-row>
    <b-row>
      <b-col>
        <fcc-table
          striped
          hover
          pdf
          xls
          csv
          responsive
          search
          pagination
          field-visibility
          :titlePage="titlePage"
          :titlePDF="titlePage"
          :fields="fields"
          :items="items"
          :porPage="itemPorPage"
          @row-selected="selecionaCandidatos"
        />
      </b-col>
    </b-row>

    <b-row align-h="end" v-if="items.length > 0">
      <b-col class="mb-3 text-right">
        <fcc-button
          :disabled="dadosSelecionados.length <= 0"
          @click="desfazerImportacaoCandidatosSelecionados"
          >Desfazer</fcc-button
        >
      </b-col>
    </b-row>
  </b-form>
</template>
<script>
import axios from 'axios'

export default {
  props: {
    baseUrlPublicacao: String,
    idoutfase: Number,
    controlePage: Object
  },
  data() {
    return {
      fields: [
        {
          type: 'rowSelect',
          key: 'rowSelect',
          active: true
        },
        { key: 'numpedido', label: 'Número do Pedido', sortable: true },
        { key: 'cpf', label: 'CPF', sortable: true },
        { key: 'nome', label: 'Nome', sortable: true },
        { key: 'dt', label: 'Data', sortable: true }
      ],
      items: [],
      itemPorPage: '15',
      teste: false,
      dadosSelecionados: []
    }
  },
  computed: {
    titlePage() {
      return this.teste ? 'Listagem de Candidatos de Teste' : 'Listagem de Candidatos'
    }
  },
  watch: {
    teste() {
      this.obterCandidatosImportacaoOutrasFases()
    }
  },
  created() {
    this.obterCandidatosImportacaoOutrasFases()
  },
  methods: {
    obterCandidatosImportacaoOutrasFases() {
      const body = {
        idPublicacao: this.controlePage.idpublicacao,
        idOutraFase: this.idoutfase,
        flTeste: Number(this.teste)
      }

      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .post(
          this.baseUrlPublicacao + 'PublicacaoOutrasFases/ObterCandidatosImportacaoOutrasFases',
          body,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(({ data }) => {
          this.items = data
        })
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    },
    selecionaCandidatos(itens) {
      this.dadosSelecionados = itens
    },
    desfazerImportacaoCandidatosSelecionados() {
      const body = this.dadosSelecionados.map((item) => {
        return {
          idPublicacao: this.controlePage.idpublicacao,
          idOutraFase: this.idoutfase,
          numPedido: item.numpedido
        }
      })

      this.carregaTexto(this.codeMensagem('C01'))
      axios
        .post(
          this.baseUrlPublicacao + 'PublicacaoOutrasFases/ExcluirCandidatosImportacaoOutrasFases',
          body,
          this.dadosLoginSession.fccTokenHeaders
        )
        .then(this.obterCandidatosImportacaoOutrasFases)
        .catch(this.setErrorSystem)
        .finally(this.carregaTexto)
    }
  }
}
</script>